export default __webpack_public_path__ + "img/bandage.71bd8fd5.svg";